import { Rows3, AlignJustify, List, LayoutList, Square } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { usePreferencesStore, type TableDensity } from '@/lib/store/preferencesStore';
import { DEFAULT_ADVANCED_TABLE_LABELS, type AdvancedTableLabels } from './advancedTableLabels';

type DensityLabelKey = 'densityCompact' | 'densityDefault' | 'densityComfortable' | 'densitySpacious';

const DENSITY_OPTIONS: { value: TableDensity; icon: typeof AlignJustify; labelKey: DensityLabelKey }[] = [
  { value: 'compact', icon: AlignJustify, labelKey: 'densityCompact' },
  { value: 'default', icon: List, labelKey: 'densityDefault' },
  { value: 'comfortable', icon: LayoutList, labelKey: 'densityComfortable' },
  { value: 'spacious', icon: Square, labelKey: 'densitySpacious' },
];

interface DensityToggleProps {
  labels?: Partial<AdvancedTableLabels>;
}

export function DensityToggle({ labels }: DensityToggleProps) {
  const l = { ...DEFAULT_ADVANCED_TABLE_LABELS, ...labels };
  const density = usePreferencesStore((s) => s.tableDensity ?? 'comfortable');
  const setDensity = usePreferencesStore((s) => s.setTableDensity);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-8 w-8 p-0"
          aria-label={l.densityLabel}
        >
          <Rows3 className="h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-40">
        <DropdownMenuRadioGroup value={density} onValueChange={(v) => setDensity(v as TableDensity)}>
          {DENSITY_OPTIONS.map(({ value, icon: Icon, labelKey }) => (
            <DropdownMenuRadioItem key={value} value={value}>
              <Icon className="mr-2 h-4 w-4 text-muted-foreground" />
              {l[labelKey]}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
